import * as React from "react";
import { TextField, NumberField, BooleanField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /pro/{proId}/videos — suppression : DELETE /pro/{proId}/videos/{videoId}.
// (Upload / édition : depuis l'app pro.)
export default {
  list: subResourceList({
    parentParam: "proId",
    parentLabel: "ID pro",
    canDelete: true,
    children: [
      <TextField key="title" source="title" label="Titre" />,
      <BooleanField key="published" source="published" label="Publiée" />,
      <NumberField locales="fr-FR" key="durationSec" source="durationSec" label="Durée (s)" />,
      <FrDateField key="createdAt" source="createdAt" label="Créée le" showTime />,
    ],
  }),
};
